var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Ceshi"}},[_vm._v(" Ceshi ")])}
var staticRenderFns = []

export { render, staticRenderFns }